/* Native, intent-loaded Shopify film gallery. No media element exists before a click. */
(function () {
  'use strict';
  var globalKey = '__bmFilmGalleryV1';
  if (window[globalKey]) {
    window[globalKey].init(document);
    return;
  }

  var state = {
    instances: new Map(), active: null, serial: 0,
    preference: { muted: false, volume: 1 }, overflow: null,
    init: init
  };
  window[globalKey] = state;
  var defaults = {
    play: 'Play', close: 'Close', previous: 'Previous', next: 'Next',
    loading: 'Loading video…', error: 'This video could not load. Please try again.',
    retry: 'Try again', watchOnYouTube: 'Watch on YouTube', videoOf: '{current} of {total}'
  };

  function safeURL(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      var url = new URL(value, document.baseURI);
      return /^(https?:)$/.test(url.protocol) ? url.href : '';
    } catch (_) { return ''; }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function iconButton(className, label, glyph) {
    var button = element('button', className);
    button.type = 'button';
    button.setAttribute('aria-label', label);
    var icon = element('span', '', glyph);
    icon.setAttribute('aria-hidden', 'true');
    button.appendChild(icon);
    return button;
  }

  function Gallery(root, data) {
    this.root = root;
    this.videos = data.videos;
    this.labels = Object.assign({}, defaults, data.labels || {});
    this.abort = new AbortController();
    this.rail = root.querySelector('.bm-film-gallery__rail');
    this.cards = Array.from(root.querySelectorAll('[data-bm-film-index]'));
    this.request = 0;
    this.index = -1;
    this.opened = false;
    this.dialog = null;
    this.video = null;
    this.timer = null;
    var self = this;
    var options = { signal: this.abort.signal };

    root.addEventListener('click', function (event) {
      var card = event.target.closest('[data-bm-film-index]');
      if (!card || !root.contains(card) || !isPlainClick(event)) return;
      var index = Number(card.dataset.bmFilmIndex);
      if (!Number.isInteger(index) || !self.videos[index]) return;
      if (self.open(index, card)) event.preventDefault();
    }, options);
    this.cards.forEach(function (card) { card.setAttribute('aria-haspopup', 'dialog'); });

    var previous = root.querySelector('[data-bm-rail-previous]');
    var next = root.querySelector('[data-bm-rail-next]');
    this.railPrevious = previous;
    this.railNext = next;
    if (this.rail && previous && next) {
      previous.setAttribute('aria-label', this.labels.railPrevious || this.labels.previous);
      next.setAttribute('aria-label', this.labels.railNext || this.labels.next);
      previous.addEventListener('click', function () { self.moveRail(-1); }, options);
      next.addEventListener('click', function () { self.moveRail(1); }, options);
      this.rail.addEventListener('scroll', function () { self.updateRail(); }, { passive: true, signal: this.abort.signal });
      var railNavigation = root.querySelector('[data-bm-rail-nav]');
      if (railNavigation) railNavigation.hidden = this.videos.length < 2;
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(function () { self.updateRail(); });
        this.resize.observe(this.rail);
      }
      this.updateRail();
    }
    root.dataset.bmFilmReady = 'true';
  }

  Gallery.prototype.moveRail = function (direction) {
    var first = this.rail.querySelector('.bm-film-gallery__item');
    var style = getComputedStyle(this.rail);
    var gap = parseFloat(style.columnGap) || 18;
    var distance = first ? first.getBoundingClientRect().width + gap : this.rail.clientWidth;
    this.rail.scrollBy({ left: direction * distance * (style.direction === 'rtl' ? -1 : 1), behavior: reducedMotion() ? 'instant' : 'smooth' });
  };

  Gallery.prototype.updateRail = function () {
    if (!this.rail || !this.railPrevious || !this.railNext) return;
    var items = this.rail.querySelectorAll('.bm-film-gallery__item');
    if (!items.length) return;
    var rail = this.rail.getBoundingClientRect();
    var first = items[0].getBoundingClientRect();
    var last = items[items.length - 1].getBoundingClientRect();
    var rtl = getComputedStyle(this.rail).direction === 'rtl';
    this.railPrevious.disabled = rtl ? first.right <= rail.right + 3 : first.left >= rail.left - 3;
    this.railNext.disabled = rtl ? last.left >= rail.left - 3 : last.right <= rail.right + 3;
  };

  Gallery.prototype.buildDialog = function () {
    var self = this;
    var id = 'bm-film-player-' + (++state.serial);
    var dialog = element('dialog', 'bm-film-dialog');
    dialog.setAttribute('aria-labelledby', id + '-title');
    var surface = element('div', 'bm-film-dialog__surface');
    var top = element('div', 'bm-film-dialog__top');
    this.count = element('span', 'bm-film-dialog__count');
    this.closeButton = iconButton('bm-film-dialog__icon-button bm-film-dialog__close', this.labels.close, '×');
    this.closeButton.autofocus = true;
    top.append(this.count, this.closeButton);
    this.stage = element('div', 'bm-film-dialog__stage');
    this.loading = element('span', 'bm-film-dialog__loading', this.labels.loading);
    this.loading.setAttribute('role', 'status');
    this.stage.appendChild(this.loading);
    var info = element('div', 'bm-film-dialog__info');
    var copy = element('div', 'bm-film-dialog__copy');
    this.title = element('h3', 'bm-film-dialog__title');
    this.title.id = id + '-title';
    this.meta = element('p', 'bm-film-dialog__meta');
    this.cta = element('a', 'bm-film-dialog__cta');
    copy.append(this.title, this.meta, this.cta);
    var navigation = element('div', 'bm-film-dialog__navigation');
    this.previous = iconButton('bm-film-dialog__icon-button', this.labels.previous, '‹');
    this.next = iconButton('bm-film-dialog__icon-button', this.labels.next, '›');
    navigation.append(this.previous, this.next);
    info.append(copy, navigation);
    this.errorPanel = element('div', 'bm-film-dialog__error');
    this.errorPanel.hidden = true;
    this.errorPanel.setAttribute('role', 'alert');
    this.errorPanel.appendChild(element('p', 'bm-film-dialog__error-message', this.labels.error));
    var errorActions = element('div', 'bm-film-dialog__error-actions');
    this.retry = element('button', 'bm-film-dialog__retry', this.labels.retry);
    this.retry.type = 'button';
    this.fallback = element('a', 'bm-film-dialog__fallback', this.labels.watchOnYouTube);
    this.fallback.target = '_blank';
    this.fallback.rel = 'noopener noreferrer';
    errorActions.append(this.retry, this.fallback);
    this.errorPanel.appendChild(errorActions);
    this.thumbnails = element('div', 'bm-film-dialog__thumbnails');
    this.thumbnails.hidden = this.videos.length < 2;
    this.videos.forEach(function (film, index) {
      var button = element('button', 'bm-film-dialog__thumbnail');
      button.type = 'button';
      button.setAttribute('aria-label', self.labels.play + ': ' + film.title);
      button.setAttribute('aria-pressed', 'false');
      button.dataset.bmFilmThumbnail = index;
      var image = element('img');
      var poster = safeURL(film.poster);
      if (poster) image.src = poster;
      image.alt = '';
      image.width = 160;
      image.height = 90;
      image.loading = 'lazy';
      image.decoding = 'async';
      button.appendChild(image);
      button.addEventListener('click', function () { self.select(index); });
      self.thumbnails.appendChild(button);
    });
    surface.append(top, this.stage, info, this.errorPanel, this.thumbnails);
    dialog.appendChild(surface);
    this.closeButton.addEventListener('click', function () { self.close(); });
    this.previous.addEventListener('click', function () { self.select(self.index - 1); });
    this.next.addEventListener('click', function () { self.select(self.index + 1); });
    this.retry.addEventListener('click', function () { self.select(self.index); });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); self.close(); });
    dialog.addEventListener('close', function () { if (self.opened && !dialog.open) self.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var rect = surface.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) self.close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') {
        var focusable = Array.from(dialog.querySelectorAll('button:not(:disabled), a[href], video[controls], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])')).filter(function (node) { return node.getClientRects().length > 0 && node.tabIndex >= 0; });
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        return;
      }
      // Native video controls retain arrow keys for seeking and volume.
      if (event.target.closest('video, input, textarea, select') || event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        if (getComputedStyle(dialog).direction === 'rtl') direction *= -1;
        self.select(self.index + direction);
      }
    });
    document.body.appendChild(dialog);
    this.dialog = dialog;
  };

  Gallery.prototype.open = function (index, trigger) {
    if (!this.videos[index]) return false;
    if (!this.dialog) this.buildDialog();
    if (state.active && state.active !== this) state.active.close(false);
    if (!this.opened) {
      try { this.dialog.showModal(); } catch (_) { return false; }
      state.overflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.opened = true;
    }
    this.trigger = trigger;
    state.active = this;
    document.querySelectorAll('video').forEach(function (video) {
      try { video.pause(); } catch (_) { /* A separate player may be unloading. */ }
    });
    this.select(index);
    this.closeButton.focus({ preventScroll: true });
    return true;
  };

  Gallery.prototype.disposeVideo = function () {
    clearTimeout(this.timer);
    this.timer = null;
    if (!this.video) return;
    var video = this.video;
    state.preference = { muted: video.muted, volume: video.volume };
    this.video = null;
    video.pause();
    video.removeAttribute('src');
    video.removeAttribute('poster');
    video.replaceChildren();
    video.load();
    video.remove();
  };

  Gallery.prototype.setState = function (mode) {
    this.stage.dataset.state = mode;
    this.stage.setAttribute('aria-busy', mode === 'loading' ? 'true' : 'false');
    this.loading.hidden = mode !== 'loading';
    this.errorPanel.hidden = mode !== 'error';
  };

  Gallery.prototype.select = function (index, forceMP4) {
    if (!this.opened || !this.videos[index]) return;
    var self = this;
    var request = ++this.request;
    this.disposeVideo();
    this.index = index;
    var film = this.videos[index];
    this.title.textContent = film.title || '';
    this.meta.textContent = [film.topic, film.duration].filter(Boolean).join(' · ');
    this.count.textContent = String(this.labels.videoOf).replace('{current}', index + 1).replace('{total}', this.videos.length);
    this.previous.disabled = index === 0;
    this.next.disabled = index === this.videos.length - 1;
    var ctaURL = safeURL(film.ctaUrl);
    this.cta.hidden = !ctaURL || !film.ctaLabel;
    if (ctaURL) this.cta.href = ctaURL;
    else this.cta.removeAttribute('href');
    this.cta.textContent = film.ctaLabel || '';
    var youtube = safeURL(film.youtube);
    this.fallback.hidden = !youtube;
    if (youtube) this.fallback.href = youtube;
    else this.fallback.removeAttribute('href');
    this.thumbnails.querySelectorAll('button').forEach(function (button, i) { button.setAttribute('aria-pressed', String(i === index)); });
    var selectedThumbnail = this.thumbnails.children[index];
    if (selectedThumbnail && !this.thumbnails.hidden) {
      var stripBounds = this.thumbnails.getBoundingClientRect();
      var selectedBounds = selectedThumbnail.getBoundingClientRect();
      var thumbnailOffset = selectedBounds.left < stripBounds.left ? selectedBounds.left - stripBounds.left - 4 : selectedBounds.right > stripBounds.right ? selectedBounds.right - stripBounds.right + 4 : 0;
      if (thumbnailOffset) this.thumbnails.scrollBy({ left: thumbnailOffset, behavior: reducedMotion() ? 'instant' : 'smooth' });
    }
    this.setState('loading');

    // A fresh element isolates delayed play promises and media events from the next film.
    var video = element('video', 'bm-film-dialog__video');
    video.controls = true;
    video.playsInline = true;
    video.preload = 'none';
    video.muted = state.preference.muted;
    video.volume = state.preference.volume;
    video.setAttribute('aria-label', film.title || this.labels.play);
    var poster = safeURL(film.poster);
    if (poster) video.poster = poster;
    var tracks = Array.isArray(film.tracks) ? film.tracks : [];
    if (tracks.length) video.crossOrigin = 'anonymous';
    tracks.forEach(function (track) {
      var src = safeURL(track.src);
      if (!src) return;
      var node = element('track');
      node.kind = ['captions', 'subtitles', 'descriptions', 'chapters', 'metadata'].includes(track.kind) ? track.kind : 'captions';
      node.src = src;
      node.srclang = track.srclang || '';
      node.label = track.label || track.srclang || '';
      node.default = track.default === true;
      video.appendChild(node);
    });
    this.video = video;
    this.stage.prepend(video);
    function isCurrent() { return self.opened && self.request === request && self.video === video; }
    function ready() { if (isCurrent()) { clearTimeout(self.timer); self.setState('ready'); } }
    video.addEventListener('playing', ready);
    video.addEventListener('canplay', ready);
    video.addEventListener('waiting', function () {
      if (!isCurrent()) return;
      self.setState('loading');
      clearTimeout(self.timer);
      self.timer = setTimeout(fail, 25000);
    });
    video.addEventListener('volumechange', function () {
      if (isCurrent()) state.preference = { muted: video.muted, volume: video.volume };
    });
    var mp4 = safeURL(film.mp4);
    var hls = safeURL(film.hls);
    var usesHLS = !forceMP4 && hls && Boolean(video.canPlayType('application/vnd.apple.mpegurl'));
    var source = usesHLS ? hls : mp4;
    function fail() {
      if (!isCurrent()) return;
      if (usesHLS && mp4) { self.select(index, true); return; }
      clearTimeout(self.timer);
      video.pause();
      self.setState('error');
    }
    video.addEventListener('error', fail);
    if (!source) { fail(); return; }
    video.src = source;
    video.load();
    // A stalled request has a visible retry path; no automatic background retries.
    this.timer = setTimeout(fail, 25000);
    var play;
    try { play = video.play(); } catch (_) { fail(); return; }
    if (play && typeof play.then === 'function') {
      play.then(function () {
        if (!isCurrent()) { video.pause(); return; }
        ready();
      }).catch(function (error) {
        if (!isCurrent()) { video.pause(); return; }
        // Some browsers require the native play control after a source change.
        if (error && error.name === 'NotAllowedError') ready();
        else if (!error || error.name !== 'AbortError') fail();
      });
    }
    this.root.dispatchEvent(new CustomEvent('bm:film:select', { bubbles: true, detail: { id: film.id, index: index, context: this.root.dataset.bmFilmContext } }));
  };

  Gallery.prototype.close = function (restoreFocus) {
    if (!this.opened) return;
    this.opened = false;
    ++this.request;
    this.disposeVideo();
    if (this.dialog.open) this.dialog.close();
    if (state.active === this) {
      state.active = null;
      document.documentElement.style.overflow = state.overflow === null ? '' : state.overflow;
      state.overflow = null;
    }
    if (restoreFocus !== false && this.trigger && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
    this.root.dispatchEvent(new CustomEvent('bm:film:close', { bubbles: true }));
  };

  Gallery.prototype.destroy = function () {
    this.close(false);
    this.abort.abort();
    if (this.resize) this.resize.disconnect();
    if (this.dialog) this.dialog.remove();
    this.cards.forEach(function (card) { card.removeAttribute('aria-haspopup'); });
    var nav = this.root.querySelector('[data-bm-rail-nav]');
    if (nav) nav.hidden = true;
    delete this.root.dataset.bmFilmReady;
    state.instances.delete(this.root);
  };

  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function isPlainClick(event) { return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey; }

  function init(scope) {
    if (!window.HTMLDialogElement || typeof HTMLDialogElement.prototype.showModal !== 'function') return;
    // Removed section roots may otherwise retain a paused dialog in the body.
    state.instances.forEach(function (instance, root) { if (!root.isConnected) instance.destroy(); });
    var roots = Array.from(scope.querySelectorAll('[data-bm-film-gallery]'));
    if (scope.matches && scope.matches('[data-bm-film-gallery]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (state.instances.has(root)) return;
      var script = root.querySelector('.bm-film-gallery__data');
      try {
        var data = JSON.parse(script.textContent);
        if (!Array.isArray(data.videos) || !data.videos.length) return;
        state.instances.set(root, new Gallery(root, data));
      } catch (_) { /* Server-rendered source links remain usable. */ }
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-bm-film-open]');
    if (!trigger || !isPlainClick(event)) return;
    var filmID = trigger.dataset.bmFilmOpen;
    var opened = false;
    state.instances.forEach(function (instance) {
      if (opened) return;
      var index = instance.videos.findIndex(function (film) { return film.id === filmID; });
      if (index >= 0) opened = instance.open(index, trigger);
    });
    if (opened) event.preventDefault();
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    state.instances.forEach(function (instance, root) {
      if (event.target === root || event.target.contains(root)) instance.destroy();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
})();
